import { BYTES_IN_MB, FILE_ATTACHMENT_MAX_SIZE_MB } from 'constants-module';
import { Attachment as ApiAttachment } from 'types';

export const getOversizedAttachmentErrors = (
  attachments: readonly (File | ApiAttachment)[],
  otherAttachments: readonly (File | ApiAttachment)[],
  errorMessage: string,
): Record<string, string> =>
  [...attachments, ...otherAttachments].reduce<Record<string, string>>((errors, attachment) => {
    if (attachment.size > FILE_ATTACHMENT_MAX_SIZE_MB * BYTES_IN_MB) {
      const name = 'originalName' in attachment ? attachment.originalName : attachment.name;

      errors[name] = errorMessage;
    }

    return errors;
  }, {});
